import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';

import { Grid } from 'react-bootstrap';
import { Card } from 'pnnl-react-core';
import { Modal, Button, Alert, Tabs } from 'antd';

import { saveAs } from 'file-saver';
import SampleExcel from 'data/TM-30-Web-Library-Excel-Input.xlsx';

import SubmitFeedbackModal from 'components/submitFeedbackModal';

import './index.scss';

const { TabPane } = Tabs;

const Home = () => {
  // const [showBetaInfoModal, setShowBetaInfoModal] = useState(false);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);

  // useEffect(() => {
  //   const inProgress = sessionStorage.getItem('session-progress');
  //   if (!inProgress) {
  //     setShowBetaInfoModal(true);
  //   }
  // }, []);

  // const betaInfoModal = (
  //   <Modal
  //     title='Note'
  //     visible={showBetaInfoModal}
  //     onCancel={() => setShowBetaInfoModal(false)}
  //     footer={[
  //       <Button key='close' onClick={() => setShowBetaInfoModal(false)}>
  //         Close
  //       </Button>,
  //     ]}
  //   >
  //     This is a beta version of TM-30-20 calculator, not a final version.
  //   </Modal>
  // );

  return (
    <div className='overview-and-instructions'>
      {/* {betaInfoModal} */}
      <SubmitFeedbackModal
        showFeedbackModal={showFeedbackModal}
        setShowFeedbackModal={setShowFeedbackModal}
      />
      {/* <Alert
        message="This is a beta version of TM-30-20 calculator, not a final version."
        type="info"
        showIcon
      /> */}
      <Tabs defaultActiveKey='1'>
        <TabPane tab='Overview' key='1'>
          {window.location !== window.parent.location ? (
            <>
              <p>
                The Spectral Calculator is the Illuminating Engineering
                Society’s official tool for computing metrics derived from a
                light source spectral power distribution (SPD). It provides
                implementations of the{' '}
                <i>
                  IES Method for Characterizing the Color Rendition of Light
                  Sources
                </i>
                ,{' '}
                <a
                  target='_blank'
                  rel='noopener noreferrer'
                  href='https://store.ies.org/product/tm-30-20-ies-method-for-evaluating-light-source-color-rendition/'
                >
                  ANSI/IES TM-30-20
                </a>
                , and the International Commission on Illumination (CIE){' '}
                <i>
                  System for Metrology of Optical Radiation for IPRGC-Influenced
                  Responses to Light
                </i>
                ,{' '}
                <a
                  target='_blank'
                  rel='noopener noreferrer'
                  href='https://cie.co.at/publications/cie-system-metrology-optical-radiation-iprgc-influenced-responses-light-0'
                >
                  CIE S 026/E:2018
                </a>
                . It serves as the reference implementation of TM-30 and is
                maintained by the IES Color Committee.
              </p>
              <p>
                Single SPDs can be pasted directly into the application or
                uploaded in .spdx format (
                <a
                  target='_blank'
                  rel='noopener noreferrer'
                  href='https://store.ies.org/product/tm-27-20-technical-memorandum-ies-standard-format-for-the-electronic-transfer-of-spectral-data/'
                >
                  ANSI/IES TM-27-20
                </a>
                ). Multiple SPDs can be uploaded simultaneously to a User
                Library using an Excel template or multiple .spdx files. The
                User Library, which displays a table of calculation results, is
                stored only for the current session and no data is ever saved by
                the application. The User Library can be saved as a .json file
                for re-upload later, which also facilitates sharing. The .json
                file can also be imported to Excel.
              </p>
              <p>
                The tool creates specification reports as specified in TM-30
                Annex D. These reports include a footer indicating that they
                were generated with this reference tool. The graphical results
                can be output as an image (.png) or .pdf. Results can be
                downloaded in .json or .xlsx format, and SPDs can be saved in
                .spdx format. The User Library allows for batch processing of
                graphical outputs.
              </p>
              <p>
                The development of this tool was supported by the U.S.
                Department of Energy’s Lighting R&D Program, part of the
                Building Technologies Office within the Office of Energy
                Efficiency and Renewable Energy (EERE). The CIE S026
                calculations are performed using code from the{' '}
                <a
                  target='_blank'
                  rel='noopener noreferrer'
                  href='https://luox.app/'
                >
                  Luox
                </a>{' '}
                application.<sup>1</sup>
              </p>
              <p>
                Questions and feedback about this tool should be directed to{' '}
                <a href={'mailto: tools@ies.org'}>tools@ies.org</a>
              </p>
              <p>
                1. Spitschan, M. (2021). luox: Platform for calculating
                quantities related to light and lighting [Source code].
                Available from{' '}
                <a
                  target='_blank'
                  rel='noopener noreferrer'
                  href='https://github.com/luox-app/luox'
                >
                  https://github.com/luox-app/luox
                </a>
                .
              </p>
            </>
          ) : (
            <>
              <p>
                The PNNL Spectral Calculator is a public tool for computing
                metrics derived from a light source spectral power distribution
                (SPD). It currently implements the Illuminating Engineering
                Society (IES) Method for Characterizing the Color Rendition of
                Light Sources,{' '}
                <a
                  target='_blank'
                  rel='noopener noreferrer'
                  href='https://store.ies.org/product/tm-30-20-ies-method-for-evaluating-light-source-color-rendition/'
                >
                  ANSI/IES TM-30-20
                </a>
                , and the International Commission on Illumination (CIE) System
                for Metrology of Optical Radiation for IPRGC-Influenced
                Responses to Light,{' '}
                <a
                  target='_blank'
                  rel='noopener noreferrer'
                  href='https://cie.co.at/publications/cie-system-metrology-optical-radiation-iprgc-influenced-responses-light-0'
                >
                  CIE S 026/E:2018
                </a>
                . Future additions are planned.
              </p>
              <p>
                The tool creates specification reports as specified in TM-30
                Annex D. The graphical results can be output as an image (.png)
                or .pdf. Results can be downloaded in .json or .xlsx format, and
                SPDs can be saved in .spdx format. The User Library allows for
                batch processing of graphical outputs.
              </p>
              <p>
                The development of this tool was supported by the U.S.
                Department of Energy’s Lighting R&D Program, part of the
                Building Technologies Office within the Office of Energy
                Efficiency and Renewable Energy (EERE). The CIE S026
                calculations are performed using code from the{' '}
                <a
                  target='_blank'
                  rel='noopener noreferrer'
                  href='https://luox.app/'
                >
                  Luox
                </a>{' '}
                application.<sup>1</sup>
              </p>
              <p>
                Questions and feedback about this tool should be directed to
                Michael Royer at{' '}
                <a href={'mailto: michael.royer@pnnl.gov'}>
                  michael.royer@pnnl.gov
                </a>
                . Suggestions for improvement are welcome.
              </p>
              <p>
                Please cite as: Royer M, Gorantla A. 2021. PNNL Applied Lighting
                Spectral Calculator [Web Application]. Available from:{' '}
                <a
                  target='_blank'
                  rel='noopener noreferrer'
                  href='https://spectralcalculator.pnnl.gov'
                >
                  {' '}
                  https://spectralcalculator.pnnl.gov
                </a>
              </p>
              <p>
                1. Spitschan, M. (2021). luox: Platform for calculating
                quantities related to light and lighting [Source code].
                Available from{' '}
                <a
                  target='_blank'
                  rel='noopener noreferrer'
                  href='https://github.com/luox-app/luox'
                >
                  https://github.com/luox-app/luox
                </a>
                .
              </p>
            </>
          )}
        </TabPane>
        <TabPane tab='Navigation' key='2'>
          <p>
            Primary navigation occurs using the menu in the upper right corner
            of the page. There are five main sections of the application:
          </p>
          <ul>
            <li>
              <strong>Data Input</strong>: Input or recall data and initiate a
              calculation.
            </li>
            <li>
              <strong>Reports</strong>: Display results for a single SPD and
              print or save the output in a variety of formats.
            </li>
            <li>
              <strong>User Library</strong>: View a table of results for
              multiple SPDs and batch process reports.
            </li>
            <li>
              <strong>Example Library</strong>: Non-editable library of SPDs
              included for informational purposes only.
            </li>
          </ul>
        </TabPane>
        <TabPane tab='Data Input' key='3'>
          <p>
            There are multiple ways to input data, perform calculations, and
            generate reports:
          </p>
          <ul>
            <h4>Call from Library</h4>
            <p>
              This method can be used to generate reports for an SPD that is in
              the Example Library or User Library. Each dropdown menu is
              searchable. The Example Library is pre-populated with a selection
              of SPDs. SPDs can be added to the User Library by using an Excel
              Template, .spdx files, or a .json file saved from this
              application. More details are provided in the Library Functions
              section of this user guide.
            </p>
            <p>
              Once an SPD is selected from the dropdown, its information will be
              displayed and an option to generate reports will be presented. For
              SPDs in the User Library, the metadata can be edited here (it will
              also update the library entry). The Unique Identifier is used to
              title reports, but all fields are optional. For SPDs in the
              Example Library, the metadata cannot be edited.
            </p>
            <h4>Import SPDX</h4>
            <p>
              This method allows data entry using an existing .spdx file. After
              uploading a file, an option to calculate results and generate
              reports or save to the User Library will be presented. As with
              Call from Library, the metadata can be edited at this stage.
            </p>
            <p>
              Note that .spdx files can be generated from the Reports, User
              Library, or Example Library pages.
            </p>
            <h4>Paste Data</h4>
            <p>
              This method allows for directly pasting data into fields within
              the application. Begin by entering information about the start
              wavelength, end wavelength, and wavelength interval for the data
              you wish to paste. Once this information is provided, a table is
              generated that allows for pasting the SPD and associated metadata.
              Once information is pasted, the results can be calculated and
              reports generated or the SPD can be saved to the User Library.
            </p>
          </ul>
        </TabPane>
        <TabPane tab='Results' key='4'>
          <p>
            The Results page shows calculated data for an individual SPD. It
            includes the Simple, Intermediate, and Advanced layouts specified in
            ANSI/IES TM-30-20 Annex D, as well as numerical data. The graphics
            and tables are populated after completing calculations, which are
            initiated from the Data Input page or a Library page.
          </p>
          <p>
            From the Results page, the SPD used to generate the displayed
            results can be added to the User Library, and data can be downloaded
            as one of several file types:
          </p>
          <ul>
            <li>
              <strong>Image</strong>: A vector graphic (PNG) of the report
              currently displayed
            </li>
            <li>
              <strong> PDF</strong>: A PDF of the report currently displayed
            </li>
            <li>
              <strong> SPDX</strong>: A standardized file format for the SPD
              only
            </li>
            <li>
              <strong>JSON</strong>: This data file includes all the input and
              output data associated with the calculation
            </li>
            <li>
              <strong>XLSX</strong>: An Excel file that includes all the input
              and output data associated with the calculation
            </li>
          </ul>
          <p>
            In addition, each individual chart within the page can be saved as
            an image (.png) by clicking the button that appears on mouseover.
            Options for changing the display of some graphics can be found in
            the menu that appears in the upper right corner when the cursor is
            positioned over the chart.
          </p>
        </TabPane>
        <TabPane tab='Libraries' key='5'>
          <p>
            The Spectral Calculator includes two libraries, the Example Library
            and the User Library. The pre-loaded SPDs of the Example Library are
            for informational purposes only. These SPDs were collected from
            existing literature and measurements. This set of SPDs is generally
            not sufficient for research purposes. The Example Library cannot be
            edited or saved locally.
          </p>
          <p>
            The User Library allows for simultaneous upload and calculation of
            thousands of SPDs at a time. Individual SPDs can be added to the
            library from the Data Input or Results pages. Multiple SPDs can be
            added from the Data Input or User Library pages using the Add New
            SPDs button. Multiple SPDs can be input by: (1) downloading, pasting
            data into, and then uploading a pre-formatted Excel file, (2)
            uploading a library that has previously been generated and saved as
            a .json data file, or (3) uploading a group of properly formatted
            .spdx files. New uploads can be appended to or overwrite the
            existing User Library.
          </p>
          <p>
            The Excel file input mechanism includes accompanying fields for
            metadata that describes the SPD. It is recommended that at least
            some of this data is entered, at the time of upload or after upload,
            to facilitate searching and recalling SPDs. The Unique Identifier
            field is used as the title for reports.
          </p>
          <p>
            When SPD data is uploaded to the User Library, all calculations will
            be performed. For many thousands of SPDs, the upload and calculation
            time can be considerable.
          </p>
          <p>
            The data in the User Library is only active for the session. If you
            leave the application webpage, the data will be lost. The calculated
            data can be downloaded in .json format for later re-upload to the
            library. This also facilitates sharing of the data (e.g., a
            manufacturer or researcher can share a library of their SPDs).
          </p>
          <p>
            Both libraries offer sortable and searchable data. You can change
            the columns displayed in the table, filter the data based on values
            for any of the numerical quantities, and sort the data based on
            values in a given column. You can also preview and open the Results
            page for a given SPD.{' '}
          </p>
          <p>
            The plus at the beginning of each row in the Library can be used to
            expand the data for that SPD (e.g., all 16 of the TM-30 Local Chroma
            Shift values).{' '}
          </p>
          <p>
            Using the check boxes, images (.png format) for any (or all) of the
            reports can be downloaded for the selected SPDs, using a
            customizable file name based on the metadata. The results for SPDs
            that are checked, filtered, or the whole library can be downloaded
            to a JSON file for sharing or re-upload at a later time. Remember,
            the User Library is not saved to the server, and is lost when you
            navigate away from the TM-30 web application. If you wish to have
            access to your library later, be sure to download it.
          </p>
        </TabPane>
        <TabPane tab='Version' key='6'>
          <h3>What's New</h3>
          <ul>
            <li>January 1, 2022: Initial Release</li>
          </ul>
        </TabPane>
        {/* <TabPane tab="Citation for Alpha-Opic calculations" key="6">
          <h3>Citation for Alpha-Opic calculations</h3>
          <ul>
            <li>
              Spitschan, M. (2021). luox: Platform for calculating quantities
              related to light and lighting [Software]. Available from{' '}
              <a
                href="https://luox.app/"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://luox.app/
              </a>
              .
            </li>
            <li>
              Spitschan, M., Stefani, O., Blattner, P., Gronfier, C., Lockley,
              S. W., & Lucas, R. J. (2019) How to report Light exposure in human
              chronobiology and sleep research experiments. _Clocks & Sleep_.
              2019; 1(3):280-289. DOI: [10.3390/clockssleep1030024](
              <a
                href="https://doi.org/10.3390/clockssleep1030024"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://doi.org/10.3390/clockssleep1030024
              </a>
              ).
            </li>
            <li>
              Spitschan, M. (2021). luox: Platform for calculating quantities
              related to light and lighting [Source code]. Available from{' '}
              <a
                href="https://github.com/luox-app/luox"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://github.com/luox-app/luox.
              </a>
            </li>
          </ul>
        </TabPane> */}
      </Tabs>
    </div>
  );
};

export default Home;
